import React from 'react';

import {
  PersonalizationCard,
  usePersonalizationWidgetData,
} from '@vp/design-personalization-widget';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { PersonalizationCardError } from './PersonalizationCardError';

export interface PersonalizationCardWrapperProps {
  hasApiError: boolean;
}

export const PersonalizationCardWrapper: React.FC<PersonalizationCardWrapperProps> = ({
  hasApiError,
}) => {
  const { t } = useLocalizations();
  const { designPersonalizationError } = usePersonalizationWidgetData();

  if (designPersonalizationError) {
    return null;
  }

  return (
    <>
      <PersonalizationCard />
      {hasApiError && <PersonalizationCardError message={t('brandkit-api-error')} />}
    </>
  );
};
